import type { RouteObject } from "react-router-dom";
import { addSlashes } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import { MySpaceRecruitment } from "@/utils/lazyLoadComponents";

// `ROOT` must stay "recruitment" — the sidebar link for this My Space section
// is backend-driven (`url: /${item.key}`, key = kebab-case of the platform
// section's `name`, which is 'Recruitment') and isn't looked up anywhere
// on the frontend.
export enum MS_RECRUITMENT_PATH_SEGMENTS {
  ROOT = "recruitment",
}

export const myspaceRecruitmentRoutes: RouteObject = {
  path: MS_RECRUITMENT_PATH_SEGMENTS.ROOT,
  handle: { breadcrumb: "Refer a Candidate" },
  HydrateFallback: Spinner,
  children: [{ index: true, Component: MySpaceRecruitment }],
};

export const MS_RECRUITMENT_PATHS = Object.freeze({
  ROOT: addSlashes(MS_RECRUITMENT_PATH_SEGMENTS.ROOT),
});
